import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * Enrich-gate login popup: hosts the shared <app-cli-providers> connect UI in a
 * dialog and closes with `true` once a provider signs in, so the enrich run can
 * continue. Closes with `false` on cancel. Opened from the Enrich action when the
 * user has not signed in to their own CLI yet.
 */
@Component({
  selector: 'app-cli-login-dialog',
  templateUrl: './cli-login-dialog.component.html',
  styleUrls: ['./cli-login-dialog.component.css'],
})
export class CliLoginDialogComponent {
  constructor(private dialogRef: MatDialogRef<CliLoginDialogComponent, boolean>) {}

  onConnected(): void { this.dialogRef.close(true); }
  cancel(): void { this.dialogRef.close(false); }
}
